<template>
  <div class="secondary-toolbar d-flex align-center justify-end">
    <v-btn
      rounded
      small
      depressed
      outlined
      color="secondary"
      class="font-hemi-head mr-1"
      @click="promptImpostazioni"
    >
      <v-icon x-small :left="!is_mobile">settings</v-icon>
      <span class="quick-mode-name d-none d-sm-flex">
        {{ asta_mode_name }}
      </span>
      <v-icon small :right="!is_mobile">expand_more</v-icon>
    </v-btn>

    <v-menu offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          class="secondary-toolbar-new-badge mr-1"
          color="error"
          content="NEW"
          offset-x="20"
          offset-y="8"
          overlap
        >
          <v-btn
            fab
            x-small
            depressed
            class="secondary-toolbar-btn con-ombra"
            title="Scegli visuale"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon small>view_module</v-icon>
          </v-btn>
        </v-badge>
      </template>

      <v-list dense dark class="secondary-toolbar-layout-menu navy darken-1">
        <v-subheader class="secondary-toolbar-layout-menu-title">
          Scegli visuale
        </v-subheader>
        <v-list-item
          v-for="layout in layoutOptions"
          :key="layout.value"
          :class="{
            'secondary-toolbar-layout-menu-item--active':
              isLayoutOptionActive(layout.value),
          }"
          @click="selectLayout(layout.value)"
        >
          <v-list-item-icon class="mr-3">
            <v-icon small>{{ layout.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ layout.text }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ layout.subtitle }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon
            v-if="isLayoutOptionActive(layout.value)"
            class="ml-3"
          >
            <v-icon small color="accent">check</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn
      fab
      x-small
      depressed
      class="secondary-toolbar-btn mr-1 con-ombra"
      :title="useSound ? 'Disattiva audio' : 'Attiva audio'"
      @click="toggleUseSound"
    >
      <v-icon small>{{ useSound ? "volume_up" : "volume_off" }}</v-icon>
    </v-btn>

    <v-btn
      v-if="!Config.STANDALONE && !is_mobile"
      fab
      x-small
      depressed
      class="secondary-toolbar-btn mr-1 con-ombra"
      @click="promptSaveRose"
    >
      <v-icon small>save</v-icon>
    </v-btn>

    <v-btn
      v-if="!Config.STANDALONE && !is_mobile"
      fab
      x-small
      depressed
      class="secondary-toolbar-btn mr-1 con-ombra"
      @click="checkAllineamentoRose(true)"
    >
      <v-icon small>sync</v-icon>
    </v-btn>
  </div>
</template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import Constants from "../../js/constants";
import Config from "../../../config-app/config";

export default {
  name: "secondary-toolbar",
  mixins: [mixins],
  methods: {
    promptImpostazioni() {
      db.emit("showImpostazioni");
    },
    toggleUseSound() {
      this.$store.dispatch("setUseSound", this.useSound ? 0 : 1);
    },
    selectLayout(layout) {
      this.$store.dispatch("switchLayout", layout);
    },
    isLayoutOptionActive(layout) {
      if (layout === Constants.LAYOUT.PANORAMICA) {
        return this.isLayoutPanoramica && !this.is_mobile;
      }

      return !this.isLayoutPanoramica || this.is_mobile;
    },
  },
  computed: {
    ...Vuex.mapGetters(["is_mobile", "isLayoutPanoramica", "useSound"]),
    layoutOptions() {
      return [
        {
          text: "Tavolo",
          subtitle: "Consigliato per schermi mobile/tablet",
          value: Constants.LAYOUT.MAIN,
          icon: "circle",
        },
        {
          text: "Panoramica",
          subtitle: "Consigliato per schermi desktop",
          value: Constants.LAYOUT.PANORAMICA,
          icon: "view_module",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.secondary-toolbar {
  min-width: 0;
}

.secondary-toolbar-btn {
  background: var(--v-navy-darken1) !important;
  color: white !important;
  font-weight: bold;
}

.secondary-toolbar-btn:hover {
  background: var(--v-navy-base) !important;
}

.secondary-toolbar-new-badge::v-deep .v-badge__badge {
  font-size: 8px;
  height: 13px;
  letter-spacing: 0;
  line-height: 13px;
  min-width: 20px;
  padding: 0 3px;
}

.secondary-toolbar-layout-menu {
  min-width: 220px;
}

.secondary-toolbar-layout-menu-title {
  color: var(--v-navy-lighten3) !important;
  font-size: 11px;
  font-weight: bold;
  height: 28px;
  letter-spacing: 0;
  line-height: 28px;
}

.secondary-toolbar-layout-menu::v-deep .v-list-item__icon i,
.secondary-toolbar-layout-menu::v-deep .v-list-item__title {
  color: var(--v-navy-lighten3) !important;
}

.secondary-toolbar-layout-menu::v-deep .v-list-item__subtitle {
  color: var(--v-navy-lighten2) !important;
  font-size: 11px;
}

.secondary-toolbar-layout-menu::v-deep
  .v-list-item:not(.secondary-toolbar-layout-menu-item--active):hover {
  background: rgba(255, 255, 255, 0.08);
}

.secondary-toolbar-layout-menu::v-deep
  .v-list-item:not(.secondary-toolbar-layout-menu-item--active):hover
  .v-list-item__icon
  i,
.secondary-toolbar-layout-menu::v-deep
  .v-list-item:not(.secondary-toolbar-layout-menu-item--active):hover
  .v-list-item__title,
.secondary-toolbar-layout-menu::v-deep
  .v-list-item:not(.secondary-toolbar-layout-menu-item--active):hover
  .v-list-item__subtitle {
  color: white !important;
}

.secondary-toolbar-layout-menu-item--active {
  background: var(--v-navy-darken2);

  &::v-deep .v-list-item__icon i,
  &::v-deep .v-list-item__title,
  &::v-deep .v-list-item__subtitle {
    color: white !important;
  }

  &::v-deep .v-list-item__icon:last-child i {
    color: var(--v-accent-base) !important;
  }
}

.quick-mode-name {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
